import request from '../utils/request';

// 发货中心分页查询
export const pageShippingCenterOrders = (params = {}) => {
  return request({
    url: '/goods-order/shipping-center/page',
    method: 'post',
    data: params
  });
};

// 手动发货
export const manualShipOrder = (data) => {
  return request({
    url: '/goods-order/manual-ship',
    method: 'post',
    data
  });
};

// 自动发货（打单发货）
export const autoShipOrder = (data) => {
  return request({
    url: '/goods-order/ship/order',
    method: 'post',
    data
  });
};
